import { API_BASE_URL } from '../config';

// A failed fetch() call (offline, DNS failure, server unreachable, CORS) throws
// a raw browser TypeError like "Failed to fetch" with no response at all. That's
// distinct from the server responding with an error status, so it's translated
// to friendly copy here rather than surfaced verbatim to the user.
function networkErrorMessage() {
  return navigator.onLine === false
    ? 'No internet connection. Please check your network and try again.'
    : 'Could not reach the server. Please check your connection and try again.';
}

export async function apiFetch(token, path, options = {}) {
  const headers = { ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });
  } catch (err) {
    throw new Error(networkErrorMessage());
  }

  if (response.status === 204) return null;

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    const error = new Error(data?.detail ? String(data.detail) : `Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }

  return data;
}
